import swal from "sweetalert";
import api from "./axiosSetup";

/**
 * دریافت لینک پرداخت
 * @param {number|string} id - شناسه قسط
 * @param {string} [amount] - مبلغ دلخواه (اختیاری)
 */
const getPaymentLink = async (id, amount) => {
    if (!id) {
        console.error("❌ Installment ID is required for getPaymentLink()");
        swal("خطا", "شناسه قسط ارسال نشده است!", "error");
        return;
    }

    try {
        // اگر مبلغ کاستوم بود، کاماهاش رو حذف میکنیم
        const config = {
            params: amount ? { amount: amount.replace(/,/g, '') } : {}
        };

        const response = await api.get(`/installment/pay/${id}`, config);
        const data = response.data;

        if (data?.ok) {
            if (data.type === "redirect" && data.url) {
                window.location.href = data.url;
            } else if (data.type === "form" && data.form) {
                const container = document.createElement("div");
                container.style.display = "none";
                container.innerHTML = data.form;
                document.body.appendChild(container);
                const createdForm = container.querySelector("form");
                if (createdForm) {
                    createdForm.submit();
                    setTimeout(() => {
                         if(document.body.contains(container)) document.body.removeChild(container);
                    }, 2000);
                } else {
                    swal("خطا", "فرم پرداخت یافت نشد.", "error");
                }
            } else {
                swal("خطا", "پاسخ دریافتی از درگاه پرداخت معتبر نیست.", "error");
            }
        } else {
            swal("خطا", data?.message || "در دریافت لینک پرداخت خطایی رخ داد.", "error");
        }

    } catch (error) {
        console.error("💥 Payment link error:", error);

        // --- اصل کاری اینجاست: گرفتن مسیج ارور از بک‌اند ---
        const serverMessage = error.response?.data?.message;
        
        if (serverMessage) {
            // نمایش پیام دقیق سرور (مثل: مبلغ وارد شده نمی‌تواند بیشتر باشد)
            swal("خطا", serverMessage, "error");
        } else {
            // پیام پیش‌فرض اگه سرور چیزی نگفت
            swal("خطا", "ارتباط با سرور پرداخت برقرار نشد.", "error");
        }
    }
};

export default getPaymentLink;